module.exports = __webpack_public_path__ + "static/media/painter talking.8e3f66c5.gif";